// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xcYN","name":"Header_name__3huut","birthday":"Header_birthday__3SSEO","skeleton":"Header_skeleton__2ifd_"};